// extracted by mini-css-extract-plugin
export default {"container":"MapImage_container__1WKmf","map":"MapImage_map__GDAZF"};